var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70555 2.33642L11.5535 5.19826L4.3446 12.4424L1.4983 9.58059L8.70555 2.33642ZM13.7145 1.64621L12.4444 0.369929C11.9536 -0.12331 11.1566 -0.12331 10.6641 0.369929L9.44748 1.59248L12.2954 4.45434L13.7145 3.0283C14.0952 2.64572 14.0952 2.02877 13.7145 1.64621ZM0.00792508 13.6031C-0.0439034 13.8375 0.166693 14.0476 0.399974 13.9906L3.5735 13.2173L0.727197 10.3555L0.00792508 13.6031Z",
    fill: "#505767"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e8663f27105e19f5b05e3eb254ab13bd.svg";
export { ForwardRef as ReactComponent };